import { render, staticRenderFns } from "./MaterialAvatar.html?vue&type=template&id=2940676e&scoped=true&"
import script from "./MaterialAvatar.ts?vue&type=script&lang=ts&"
export * from "./MaterialAvatar.ts?vue&type=script&lang=ts&"
import style0 from "./MaterialAvatar.scss?vue&type=style&index=0&id=2940676e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2940676e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VIcon,VImg})
